import { useTranslation } from "react-i18next";
import { usePergunta } from "../contexts/PerguntaContext";
import { useSalvarConversaNoStorage } from "./SalvarConversaNoStorage";
import { useUser } from "../empreenderUI/UserContext";
import { obterAcessoHumano } from "../lib/acessoHumano";

// Abre o cartão do WhatsApp na conversa. Usado pelo "O que faltou?" e pelo atalho do rodapé.
export const useFalarComAtendente = (slugAtual: string) => {
  const { t } = useTranslation();
  const { setPergunta, conversaAtual, setContextoPendente } = usePergunta();
  const { salvarConversa } = useSalvarConversaNoStorage();
  const acesso = obterAcessoHumano(useUser()?.user);

  const chamarAtendente = () => {
    setContextoPendente(null);
    salvarConversa(slugAtual, conversaAtual, { usuario: t("preciso_mais_ajuda") });
    setPergunta("pediu_ajuda");
  };

  return { acesso, chamarAtendente };
};
